import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

// Audit NRC-040: email-me-this-result capture on every calculator.
export const ToolEmailCapture = ({ tool, toolName, resultRef }) => {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email || busy) return;
    const resultText = (resultRef?.current?.innerText || "").slice(0, 3800);
    setBusy(true);
    try {
      await api.post("/tools/email", { email, tool, tool_name: toolName, result_text: resultText || `${toolName} — run at ninjarunclub.com/tools/${tool}` });
      setSent(true);
    } catch {
      toast.error("Could not send. Try again.");
    } finally {
      setBusy(false);
    }
  };

  if (sent) {
    return (
      <div className="border border-fog p-5 bg-paper" data-testid="tool-email-sent">
        <p className="font-mono-label text-ink/60">CHECK YOUR INBOX.</p>
        <p className="text-sm text-ink/70 mt-2">
          Result saved. One useful training email a week follows — unsubscribe anytime.
        </p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} className="border border-fog p-5 bg-paper" data-testid="tool-email-capture">
      <p className="font-mono-label text-ink/60">SAVE YOUR NUMBERS</p>
      <p className="text-sm text-ink/70 mt-2">Email yourself this result plus the training guide that goes with it.</p>
      <div className="mt-3 flex gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          data-testid="tool-email-input"
          className="flex-1 min-w-0 border border-fog bg-white px-3 py-2.5 text-sm focus:outline-none focus:border-ink"
        />
        <button
          type="submit"
          disabled={busy}
          data-testid="tool-email-submit"
          className="bg-ink text-white font-mono-label px-4 py-2.5 hover:bg-coal transition-colors disabled:opacity-60 whitespace-nowrap"
        >
          {busy ? "SENDING…" : "EMAIL ME THIS RESULT"}
        </button>
      </div>
    </form>
  );
};

export const GoDeeper = ({ links }) => {
  if (!links?.length) return null;
  return (
    <div className="border border-white/15 p-5" data-testid="tool-go-deeper">
      <h2 className="font-mono-label text-white/40">GO DEEPER</h2>
      <ul className="mt-3 space-y-2">
        {links.map((l) => (
          <li key={l.path}>
            <Link to={l.path} className="text-sm text-white/70 underline underline-offset-4 hover:text-white transition-colors">
              {l.label} →
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
